export default {
  control: 'text',
  valueUpdate: 'input',
  validators: {
    range: { blockInput: false /*, message */ },
    decimalLength: { blockInput: false /*, message */ },
  },
};
